<script setup lang="ts">
import type { Address } from '@/types/Address';

defineProps<{
    address: Address
}>();
</script>
<template>
    {{ address.line1 }}
    {{ address.line2 }}<br>
    {{ address.city }}, {{ address.state }} {{ address.postcode }}<br>
    {{ address.country }}
</template>
